import { CONSTANTS_SETTINGS } from 'config/settingsContainer';

/**
 * Does this org have a camera integration switched on — Verkada, VORTEX, or both.
 *
 * 🛑 A PURE PREDICATE OVER THE SETTINGS ARRAY, and it lives here rather than only as a
 * selector because two very different modules need the same answer and one of them cannot
 * afford the other's imports. `settings/selectors` reaches billing and feature flags, which
 * reach firebase; `app/selectors` is the core readiness module every route gate runs
 * through, and pulling that graph into it broke the app and devices selector suites at
 * IMPORT time — before a single assertion ran.
 *
 * So the rule stays in one place and both sides read it: `selectIsCamerasModuleEnabled`
 * wraps it for the surfaces that already live in the settings graph, and app/selectors
 * applies it to the org settings it reads for itself. Duplicating the two setting ids
 * instead is exactly how "is Cameras on" ends up meaning two things.
 *
 * ⚠️ It answers ENABLED, not entitled and not synced. Whether the org is billed for the
 * module is `selectAvailableModules`; whether any camera has ever arrived is
 * `orgHasCameras`. This is only the flag an administrator turns on.
 *
 * @param {Array} orgSettings - the merged org settings rows for the current profile
 * @returns {boolean}
 */
export const isCamerasModuleOn = (orgSettings) =>
	(orgSettings || []).some(
		(setting) =>
			(setting.defaultSettingID === CONSTANTS_SETTINGS.VERKADA_MODULE ||
				setting.defaultSettingID === CONSTANTS_SETTINGS.VORTEX_MODULE) &&
			Number(setting.value) === 1
	);

export default isCamerasModuleOn;
